<div fxLayout="row" fxLayoutAlign="space-between center" class="w-100 pl-16 pr-16 pt-16 pb-24" fxFlex>
    <ui-kit-svg class="i-24 c-primary-gray-900 pointer" name="ic_arrow_left" (click)="previousClicked()"></ui-kit-svg>
    <div class="pointer custom-calendar-header-typography no-select" [commonsClickById]="clickBindings" [innerHtml]="label | safeHtml"></div>
    <ui-kit-svg class="i-24 c-primary-gray-900 pointer" name="ic_arrow_right" (click)="nextClicked()"></ui-kit-svg>
</div>
